/**
 * Coach account server function — auth plus delegation to
 * `~/lib/server/coach-account`. The account value is the one billing-state
 * answer the coach screens read.
 *
 * Aliases: coach account function, account state api
 */

import { createServerFn } from "@tanstack/react-start";

import { requireNovaCoachAuth } from "~/lib/coach-middleware";
import type { CoachAccount } from "~/lib/shared/coach-account";

// Client-safe re-export so route components never import from ~/lib/server.
export type {
  CoachAccount,
  CoachLifecycle,
  CoachTier,
} from "~/lib/shared/coach-account";

export const getCoachAccount = createServerFn({ method: "GET" })
  .middleware([requireNovaCoachAuth])
  .handler(async ({ context }): Promise<CoachAccount> => {
    const { buildCoachAccount } = await import("~/lib/server/coach-account");
    return buildCoachAccount(context.coach);
  });
